"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { useUserTrackingContext } from '@/context/UserTrackingContext';

/**
 * RouteChangeDetector - Detects route changes in Next.js App Router
 * This component helps ensure page tracking works properly with client-side navigation
 */
export function RouteChangeDetector() {
  const { forcePageTracking } = useUserTrackingContext();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previousKeyRef = useRef<string>("");

  useEffect(() => {
    const key = `${pathname || ""}?${searchParams?.toString() || ""}`;
    if (previousKeyRef.current === key) {
      return;
    }
    previousKeyRef.current = key;
    const timer = setTimeout(() => {
      forcePageTracking();
    }, 100);
    return () => clearTimeout(timer);
  }, [forcePageTracking, pathname, searchParams]);

  return null;
}
